import React from 'react'
import { decodeJWT } from 'utils'

const Permission = ({ permissions, children, ...props }) => {
  try {
    const context =
      localStorage.getItem('accessToken') &&
      decodeJWT(localStorage.getItem('accessToken'))

    if (!context) {
      // console.log('🔒 [PERMISSION] No context')
      return null
    }

    // console.log('🔒 [PERMISSION] Context:', {
    //   permission: context.permission,
    //   permissions: context.permissions,
    //   role: context.role,
    //   username: context.username
    // })

    // Support both 'permission' (singular) and 'permissions' (plural) fields in JWT
    const userPermissions = Array.isArray(context.permission)
      ? context.permission
      : Array.isArray(context.permissions)
      ? context.permissions
      : []

    // console.log('🔒 [PERMISSION] User permissions:', userPermissions)
    // console.log('🔒 [PERMISSION] Required permissions:', permissions)

    if (
      !permissions ||
      permissions.length === 0 ||
      permissions.filter((p) => userPermissions.includes(p)).length
    ) {
      // console.log('✅ [PERMISSION] Access granted')
      return React.cloneElement(children, props)
    }

    // console.log('❌ [PERMISSION] Access denied')
    return null
  } catch (error) {
    console.error('❌ [PERMISSION] Error:', error)
    return null
  }
}

export default Permission
